import styles from "styles/BasketItem.module.scss";
import Title from "components/Title";
import GetIcon from "components/GetIcon";
import Quantity from "components/Quantity";
import { BasketContext } from "context/BasketContext";
import { useContext } from "react";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const BasketItem = ({ data }) => {
    const { basketItems, setBasketItems, setBasketTotal, itemStocks } = useContext(BasketContext);

    const removeItemFromBasket = () => {
        let arr = [...basketItems];
        const index = arr.indexOf(data);
        if (index !== -1) {
            let removed = parseFloat(arr[index].price) * arr[index].quantity;
            arr.splice(index, 1);
            setBasketItems(arr);
            setBasketTotal((total) => total - removed);

            toast.error("Producto removido del carrito!", {
                position: "bottom-right",
                autoClose: 700,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                    backgroundColor: '#f44336',
                    color: 'white',
                    fontWeight: 'bold',
                },
                progressStyle: {
                    backgroundColor: 'white',
                },
            });
        }
    };

    return (
        <div className={styles.item}>
            <div className={styles.img}>
                <img src={data.image_url} alt="" />
            </div>
            <div className={styles.detail}>
                <div className={styles.title}>
                    <Title txt={data.title} size={16} transform="capitalize" />
                </div>
                <div className={styles.priceContainer}>
                    <small className={styles.singlePrice}>{parseFloat(data.price).toFixed(2)}</small>
                    <small className={styles.quantityN}>{data.quantity}</small>
                    <small className={styles.totalPrice}> ₡ {`${(parseFloat(data.price) * data.quantity).toFixed(2)}`}</small>
                </div>
                <Quantity
                    data={data}
                    isInCart={true}
                    min={1}
                    max={itemStocks[data.id] || data.quantity}
                />
            </div>
            <div className={styles.removeItem}>
                <button type="button" onClick={removeItemFromBasket}>
                    <GetIcon icon="BsDash" size={17} />
                </button>
            </div>
        </div>
    );
};

export default BasketItem;
